var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 15.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m3.974-9.466a.833.833 0 1 0-1.28-1.067L7.695 8.565c-.289.347-.451.539-.58.657l-.006.004-.005-.004c-.14-.106-.32-.282-.638-.601l-1.21-1.21A.833.833 0 1 0 4.078 8.59l1.21 1.21.033.033c.272.272.534.534.778.719.272.206.63.4 1.088.379.457-.02.796-.246 1.049-.476.226-.206.463-.49.709-.786l.03-.037z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessFilled);
export default ForwardRef;